<template lang="pug">
UiPage(:title="$t('resellers.title')")
  template(#actions)
    UiButton(
      @click="addReseller()"
      icon="Plus"
    ) {{ $t("actions.add") }}
  .container
    UiCard
      UiCardSection
        RestTable(
          namespace="resellers"
          :headers="headers"
          ref="resellersTable"
          :fetch-handler="getData"
          embed
        )
          template(#cell:name="{ item }")
            RouterLink(:to="`/resellers/${item.id}/edit`") {{ item.name }}
          template(#cell:actions="{ item }")
            UiButton(
              size="sm"
              variant="smooth-danger"
              icon="Trash"
              @click="deleteReseller(item)"
            ) {{ $t("actions.delete") }}
  CreateResellerModal(
    ref="ResellerCreateModal"
    @done="reloadList"
  )
</template>

<script>
import ApiResellers from "@/api/resellers.js";
import CreateResellerModal from "@/modals/Resellers/create.vue";

export default {
  components: {
    CreateResellerModal,
  },

  data() {
    return {};
  },

  computed: {
    headers() {
      return [
        {
          key: "name",
          label: "Name",
          width: "40%",
          sortable: true,
        },
        {
          key: "company_id",
          label: "BusinessId",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ];
    },
  },

  methods: {
    reloadList() {
      this.$refs.resellersTable.fetchData();
    },

    getData(params, config) {
      return ApiResellers.fetchResellers(params, config).then((resp) => {
        return {
          items: resp.data.resellers,
          meta: resp.data.meta,
        };
      });
    },

    addReseller() {
      this.$refs.ResellerCreateModal.open(null);
    },

    deleteReseller(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiResellers.deleteReseller(item.id).then((resp) => {
          this.reloadList();
        });
      });
    },
  },
};
</script>
